// DeleteModal.js
import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

const DeleteModel = ({
  isOpen,
  toggle,
  entityName,
  entityLabel,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>
        Are you sure you want to delete
        <b>{entityLabel || entityName}</b>?
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Confirm Delete
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DeleteModel
